module.exports = "/images/ss.svg?217a043c93828933cb726739a35725d3";